import React from 'react';
import { Button, Popconfirm, Row, Col, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';

const ActionsColumn = ({
    record,
    isEditing,
    onSave,
    onCancel,
    onEdit,
    onDelete,
    disabled
}) => {

    const editable = isEditing(record);

    if (editable) {
        return (
            <Row gutter={[8, 8]} justify="center">
                <Col>
                    <Tooltip title="Guardar Habilidad">
                        <Button
                            size="small"
                            onClick={() => onSave(record)}
                            icon={<SaveOutlined/>}
                            shape='circle'
                        />
                    </Tooltip>
                </Col>
                <Col>
                    <Tooltip title="Cancelar">
                        <Popconfirm title="¿Deseas cancelar la edición?" onConfirm={onCancel}>
                            <Button
                                danger
                                size="small"
                                icon={<CloseOutlined/>}
                                shape='circle'
                            />
                        </Popconfirm>
                    </Tooltip>
                </Col>
            </Row>
        );
    }

    return (
        <Row gutter={[8, 8]} justify="center">
            <Col>
                <Tooltip title="Editar Habilidad">
                    <Button
                        size="small"
                        disabled={disabled}
                        onClick={() => onEdit(record)}
                        icon={<EditOutlined />}
                        shape='circle'
                    />
                </Tooltip>
            </Col>
            <Col>
                <Tooltip title="Eliminar Habilidad">
                    <Popconfirm
                        title="¿Deseas eliminar esta habilidad?"
                        onConfirm={() => onDelete(record)}
                    >
                        <Button
                            danger
                            size="small"
                            disabled={disabled}
                            icon={<DeleteOutlined />}
                            shape='circle'
                        />
                    </Popconfirm>
                </Tooltip>
            </Col>
        </Row>
    );
};

export default ActionsColumn;